import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EasterEgg from "./EasterEgg";
import Apply from "./Apply";
import "./App.css";

function UnderConstruction() {
  return (
    <div className="App">
      <div className="construction-container">
        <div className="construction-card">
          <div className="monogram">SB</div>
          <h1 className="name">Stephen Balhoff</h1>
          <div className="divider" />
          <p className="status-label">Site Under Construction</p>
          <p className="message">
            Something new is on the way. Check back soon.
          </p>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<UnderConstruction />} />
        <Route path="/easteregg" element={<EasterEgg />} />
        <Route path="/apply" element={<Apply />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
